import { render, staticRenderFns } from "./editDestructedAsset.vue?vue&type=template&id=c8ff7032&scoped=true&"
import script from "./editDestructedAsset.vue?vue&type=script&lang=js&"
export * from "./editDestructedAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ff7032",
  null
  
)

export default component.exports